import './bootstrap';

window.maps=require('./maps.js');